import React from 'react';
import { FaUtensils, FaStarOfDavid, FaHome, FaMapMarkedAlt, FaBook, FaLightbulb } from 'react-icons/fa';
import '../../css/common/ReligiousLifeCard.css';

const ReligiousLifeCard = ({ section, onClick }) => {
  const getIcon = (type) => {
    switch (type) {
      case 'ou-jlic':
        return <FaStarOfDavid className="religious-life-card-icon" />;
      case 'eruv':
        return <FaMapMarkedAlt className="religious-life-card-icon" />;
      case 'housing':
        return <FaHome className="religious-life-card-icon" />;
      case 'kosher-dining':
        return <FaUtensils className="religious-life-card-icon" />;
      case 'shabbat-meals':
        return <FaLightbulb className="religious-life-card-icon" />;
      case 'minyan':
        return <FaBook className="religious-life-card-icon" />;
      default:
        return <FaStarOfDavid className="religious-life-card-icon" />;
    }
  };

  return (
    <div className="religious-life-card-component" onClick={onClick}>
      <div className="religious-life-card-content">
        <div className="religious-life-card-header">
          {getIcon(section.type)}
          <h3 className="religious-life-card-title">{section.title}</h3>
        </div>
        <p className="religious-life-card-subtitle">{section.subtitle}</p>
        <div className="religious-life-card-highlights">
          {section.highlights && section.highlights.slice(0, 2).map((highlight, index) => (
            <span key={index} className="religious-life-card-highlight">
              {highlight}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReligiousLifeCard; 